//
// ─── BLOCK TYPES ────────────────────────────────────────────────────────────────
//

export const RECURRING = 'recurring';
export const EXCEPTION = 'exception';

export const BLOCK_TYPES = [ RECURRING, EXCEPTION ];

//
// ─── STATE KEYS ─────────────────────────────────────────────────────────────────
//

export const KEY_TYPE = 'type';
export const KEY_ALL_DAY = 'all_day';
export const KEY_MULTI_DAY = 'multi_day';
export const KEY_MULTI_DAY_SPAN = 'multi_day_span';
export const KEY_START_TIME = 'start_time';
export const KEY_END_TIME = 'end_time';
export const KEY_START_DATE = 'start_date';
export const KEY_START_DATE_INPUT = '_start_date_input';
export const KEY_START_DATE_OBJ = '_start_date_obj';
export const KEY_END_DATE = 'end_date';
export const KEY_END_DATE_INPUT = '_end_date_input';
export const KEY_END_DATE_OBJ = '_end_date_obj';
export const KEY_LIMIT = 'limit';
export const KEY_LIMIT_DATE_INPUT = '_limit_date_input';
export const KEY_LIMIT_DATE_OBJ = '_limit_date_obj';
export const KEY_LIMIT_TYPE = 'limit_type';
export const KEY_BETWEEN = 'between';
export const KEY_DAYS = 'days';
export const KEY_WEEK = 'week';
export const KEY_DAY = 'day';
export const KEY_MONTH = 'month';
export const KEY_TIMEZONE = 'timezone';
